<template>
  <div class="tier-tag_wrapper">
    <div class="tier-tag">
      <i
        v-if="hasIcon"
        class="mdi tier-tag_icon mr-3"
        :class="[tag.icons, isSimple ? '' : tag.icon_css_class]"
      >
      </i>
      <div
        v-if="tag.games"
        :class="tag.css_class"
        class="d-flex f-align-center flex-wrap mr-1 w-100"
      >
        <div class="text-nowrap">
          {{ $t(`tier.options.${trial || nadaPurchased ? 'free_formats' : 'other_formats'}`) }}
        </div>

        <div class="csst ml-2 z-index_4">
          <i
            class="mdi mdi-help-circle-outline text-normal my-auto"
            style="line-height: 1"
          ></i>

          <div
            class="csst_content"
            style="right: 0"
          >
            <div
              v-for="type in notPurchasedTypes"
              :key="type"
              class="text-nowrap weight_500"
            >
              {{ $t(`gametypes.groups.${type.toLowerCase()}_long`) }}
            </div>
          </div>
        </div>

        <div
          v-if="hasGamesTier"
          class="text-nowrap ml-auto"
        >
          {{ $t(`tier.options.${trial ? 'trial_tier' : 'free_tier'}`) }}
        </div>
      </div>
      <span
        v-if="tag.game"
        :class="tag.css_classs"
        class="text-nowrap mr-1"
        >{{ tag.game }}</span
      >
      <span
        v-if="tag.sub && hasTier"
        class="text-nowrap mr-1 ml-4 ml-auto"
      >
        <!-- <span v-if="tag.sub && hasTier" class="text-nowrap mr-1"> -->
        <span v-if="hasSubSlash"> / </span>

        {{ tag.sub }}
        <!-- / {{ tag.sub }} -->
      </span>
      <span
        v-if="tag.interval && hasInterval"
        class="text-nowrap"
      >
        / {{ tag.interval }}
      </span>
    </div>
    <!-- <div v-if="tag.games" class="pl-1 weight_700 text-semi-large ml-8">
      {{ tag.games }}
    </div> -->
  </div>
</template>

<script>
import { tierTags } from '@/helpers/constants'
import tier_mix from '@/mixins/tier_mix'

export default {
  name: 'TierTag',
  mixins: [tier_mix],
  props: {
    paymentInterval: String,
    customGame: String,
    customTier: String,
    hasInterval: { type: Boolean, default: true },
    hasTier: { type: Boolean, default: true },
    hasIcon: { type: Boolean, default: true },
    hasSubSlash: { type: Boolean, default: true },
    isSimple: Boolean,
    hasGamesTier: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
  computed: {
    tag() {
      const res = {
        css_class: `${this.tierTag.css_class || ''} clr-${this.customGame.toLowerCase()}`,
        icon_css_class: `${this.tierTag.css_class || ''} clr-${this.customGame.toLowerCase()}`,
        game:
          this.trial || this.free
            ? ''
            : this.$t(`gametypes.groups.${this.customGame.toLowerCase()}_long`),
        icon: this.tierTag.icon,
        sub: this.free || this.trial ? '' : this.$t(`tier.options.${this.tierTag.id}`),
        interval: this.trial || this.free ? '' : this.$t(`tier.options.${this.interval}`),
        // games: this.trial || this.free ? this.notPurchasedTypes.map(g => this.$t(`gametypes.groups.${g.toLowerCase()}_long`)).join(', ') : '',
        games: this.trial || this.free,
      }
      // console.log(res)
      return res
    },
    tierTag() {
      const options = tierTags()
      switch (this.customTier) {
        case 'FREE':
          return options[0]
        case 'TRIAL':
          return options[1]
        case 'STARTER':
          return options[2]
        case 'PREMIUM':
          return options[3]
        case 'ELITE':
          return options[4]
        default:
          return new Error('Invalid tier')
      }
    },
    free() {
      return this.customTier === 'FREE'
    },
    trial() {
      return this.customTier === 'TRIAL'
    },
    interval() {
      return this.paymentInterval
    },
  },
}
</script>
<style lang="scss" scoped>
.tier-tag_wrapper {
  --title-size: 1.25rem;
  --title-weight: 700;
  --icon-size: 1.5rem;
}
.tag-wrap {
  .tier-tag {
    flex-wrap: wrap;
  }
}
.tier-tag {
  border-radius: 4px;
  font-weight: 700;
  font-size: var(--title-size);
  font-weight: var(--title-weight);
  flex: 0;
  align-items: center;
  display: flex;
  // &_trial {
  //   color: var(--clr-white-0);
  // }
  // &_starter {
  //   color: var(--clr-blue);
  // }
  // &_premium {
  //   color: var(--clr-yellow);
  // }
  &_icon {
    font-size: var(--icon-size);
    height: var(--icon-size);
    width: var(--icon-size);
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: currentColor;
    // color: currentColor;
  }
  &_btn {
    padding: 1rem 1rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.2s;
    background: transparent;
    border-radius: 8px;
    background: var(--clr-black-1);
    &:hover {
      background: var(--clr-black-3);
    }
  }
}
</style>
